'use strict';exports.__esModule = true;var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var formatTimeFromDate = function formatTimeFromDate(dateString) {
  var date = (0, _moment2.default)(dateString);
  var formattedTime = date.format('HH:mm');
  return formattedTime;
};exports.default =

formatTimeFromDate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/formatTimeFromDate.js
// module id = 580
// module chunks = 0